import { theme } from '@theme';
import { Tooltip } from 'react-tooltip';
import styled from 'styled-components';

export const CarfaxTooltip = styled(Tooltip).attrs({
  className: 'carfax-tooltip',
})`
  &.carfax-tooltip {
    font-size: ${theme.typography.h6}px;
    font-family: ${theme.typography.fontFamily};
    font-style: ${theme.typography.normalFontStyle};
    font-weight: ${theme.typography.fontWeights.semibold};
    line-height: 15px;
    border-radius: 4px;
    background-color: ${theme.palette.darkBlue};
    color: ${theme.palette.white};
    text-align: center;
  }
`;

export const CustomTooltip = styled(Tooltip).attrs({
  className: 'custom-tooltip',
})`
  &.custom-tooltip {
    font-size: ${theme.typography.h6}px;
    font-family: ${theme.typography.fontFamily};
    font-style: ${theme.typography.normalFontStyle};
    font-weight: ${theme.typography.fontWeights.semibold};
    line-height: 15px;
    border-radius: 4px;
    background-color: ${theme.palette.darkBlue};
    color: ${theme.palette.white};
    height: auto;
    z-index: 10000;
    text-align: center;
    max-width: 200px;
  }
`;

export const ActiveToggleTooltip = styled(Tooltip).attrs({
  className: 'active-toggle-tooltip',
})`
  &.active-toggle-tooltip {
    border-radius: 4px;
    background-color: ${theme.palette.white};
    color: ${theme.palette.darkGray};
    padding: 0;
    background-color: white;
    opacity: 1;
  }
`;

export const PrivateIncentiveLookupTooltip = styled(Tooltip).attrs({
  className: 'private-incentive-lookup-tooltip',
})`
  &.private-incentive-lookup-tooltip {
    font-size: ${theme.typography.h6}px;
    font-family: ${theme.typography.fontFamily};
    font-style: ${theme.typography.normalFontStyle};
    font-weight: ${theme.typography.fontWeights.normal};
    line-height: 15px;
    border-radius: 4px;
    background-color: ${theme.palette.darkBlue};
    color: ${theme.palette.white};
    z-index: 10000;
    opacity: 1;
  }
`;

export const IncentiveTooltip = styled(Tooltip).attrs({
  className: 'incentive-tooltip',
})`
  &.incentive-tooltip {
    font-size: ${theme.typography.h6}px;
    font-family: ${theme.typography.fontFamily};
    font-style: ${theme.typography.normalFontStyle};
    font-weight: ${theme.typography.fontWeights.semibold};
    line-height: 15px;
    border-radius: 4px;
    background-color: ${theme.palette.darkBlue};
    color: ${theme.palette.white};
    height: auto;
    z-index: 10000;
    width: 200px;
  }
`;
